import { useMutation } from '@tanstack/react-query';

import { API } from '@/shared/api';

import { useUpdateAllSegmentsInEditor } from './useUpdateAllSegmentsInEditor';

const RQ_UPDATE_PROJECT_PROMPT = ['updateProjectPrompt'];

export const useUpdateProjectPrompt = () => {
  const updateSegments = useUpdateAllSegmentsInEditor();

  return useMutation({
    mutationFn: API.updateProjectPrompt,
    mutationKey: RQ_UPDATE_PROJECT_PROMPT,
    onSuccess: () => updateSegments(),
  });
};
